import type { ReactNode } from "react";
import type { MarkdownPreviewProps } from "@uiw/react-markdown-preview";
import { SearchRegular } from "@fluentui/react-icons";
import styles from "../../MarkdownContent.module.scss";

interface IImageRendererProps {
  resolveMediaUrl: (url: string | undefined) => string | undefined;
  openExpandedImage: (src: string, alt: string) => void;
}

export function createImageRenderer({
  resolveMediaUrl,
  openExpandedImage,
}: IImageRendererProps): Pick<NonNullable<MarkdownPreviewProps["components"]>, "img"> {
  return {
    img: (props: React.ImgHTMLAttributes<HTMLImageElement>): ReactNode => {
      const { className, alt, onClick: _onClick, onKeyDown: _onKeyDown, node: _node, ...imageProps } =
        props as React.ImgHTMLAttributes<HTMLImageElement> & { node?: unknown };
      const resolvedSrc = resolveMediaUrl(typeof props.src === "string" ? props.src : undefined);
      const altText = alt || "image";

      return (
        <button
          type="button"
          className={styles.imageButton}
          onClick={(): void => {
            if (resolvedSrc) {
              openExpandedImage(resolvedSrc, altText);
            }
          }}
          aria-label={`Open enlarged image: ${altText}`}
        >
          <img
            {...imageProps}
            alt={altText}
            src={resolvedSrc}
            className={`${styles.clickableImage} ${className || ""}`.trim()}
          />
          <span className={styles.imageMagnifyIcon} aria-hidden="true">
            <SearchRegular />
          </span>
        </button>
      );
    },
  };
}

